import { useTranslation } from 'react-i18next'

const Kitchen = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="kitchen-title"
      {...props}
    >
      <title id="kitchen-title">{t('antagonists:dad:components:background')}</title>
      <defs>
        <clipPath id="kitchen-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="kitchen-c">
          <path
            d="M766.43 461.73c-.8 11.44-8.18 19.1-8.6 40.75-.55 27.72-.34 61.44-.34 61.44l33.83 1.17s-.3-34.8-1.94-60.82c-1.32-20.97-9.08-27.05-11.15-41.3-1.65-11.35-2.5-22.1-2.5-22.1l-8.04.43s-.48 9.32-1.25 20.42Z"
            style={{
              fill: '#e9b800',
            }}
          />
        </clipPath>
        <clipPath id="kitchen-d">
          <path
            style={{
              fill: '#009794',
            }}
            d="m848.53 524.16 13.37 37.15h68.09l14.64-36.66-96.1-.49z"
          />
        </clipPath>
        <style>
          {
            '.f{fill:none}.g{fill:#009794}.h{fill:#f19eb0}.i{fill:#e64427}.j{fill:#ef833b}.k{fill:#e9b800}.l{fill:#ef875c}.m{fill:#ffe01c}.n{fill:#ffea97}.o{fill:#f39843}.p{fill:#f0f4f8}.q{fill:#fbf8f6}.r{fill:#940c3b}.s{fill:#8cbb15}.t{fill:#bad1d0}.u{fill:#a5ccdb}.v{fill:#cbe4e8}.w{fill:#d29dc3}.x{fill:#d8e5df}.y{fill:#e30042}.aa{fill:#444851}.ab{fill:#3b7c5e}.ac{fill:#49465a}.ad{fill:#82b658}.ae{clip-path:url(#kitchen-c)}.af{clip-path:url(#kitchen-b)}.ag{clip-path:url(#kitchen-d)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#kitchen-b)',
        }}
        id="kitchen-a"
      >
        <path
          style={{
            fill: '#d8e5df',
          }}
          d="M-185.71-144.27h2325.36V987.28H-185.71z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#bad1d0',
          }}
          d="M-237.43 797.42h2433.77v676.64H-237.43z"
        />
        <path
          style={{
            fill: '#fbf8f6',
          }}
          d="m696.96 507.7-.8 41.91 49.19.66-.32-41.91-48.07-.66zM697.22 462.06l-.79 40.98 48.07.19.23-40.51-47.51-.66zM798.63 508.1l.31 41.92-49.19.27.8-41.91 48.08-.28zM798.89 462.47l.32 40.98-48.07-.19.23-40.52 47.52-.27zM804.15 508.13l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM804.41 462.49l-.79 40.98 48.07.19.23-40.51-47.51-.66zM905.82 508.53l.31 41.92-49.19.27.8-41.91 48.08-.28zM906.08 462.9l.32 40.98-48.07-.19.23-40.52 47.52-.27zM911.34 508.56l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM911.6 462.92l-.79 40.98 48.07.19.23-40.51-47.51-.66zM1013.01 508.96l.32 41.92-49.2.27.8-41.91 48.08-.28zM1013.27 463.33l.32 40.98-48.07-.19.23-40.52 47.52-.27zM1018.53 508.99l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM1018.79 463.35l-.79 40.98 48.07.19.23-40.51-47.51-.66zM1120.2 509.39l.32 41.92-49.2.27.8-41.91 48.08-.28zM1120.46 463.76l.32 40.98-48.07-.19.23-40.52 47.52-.27zM1125.72 509.42l-.8 41.91 49.19.66-.32-41.92-48.07-.65zM1125.98 463.78l-.79 40.98 48.07.19.23-40.51-47.51-.66zM1227.39 509.82l.32 41.92-49.2.27.8-41.91 48.08-.28zM1227.65 464.19l.32 40.98-48.07-.19.23-40.52 47.52-.27zM1232.91 509.85l-.8 41.91 49.19.66-.32-41.92-48.07-.65zM1233.17 464.21l-.79 40.98 48.07.19.23-40.51-47.51-.66zM1334.58 510.25l.32 41.92-49.2.27.8-41.91 48.08-.28zM1334.84 464.62l.32 40.98-48.07-.19.23-40.52 47.52-.27zM1340.1 510.28l-.8 41.91 49.19.66-.32-41.92-48.07-.65zM1340.36 464.64l-.79 40.98 48.07.19.23-40.51-47.51-.66zM1441.77 510.68l.32 41.92-49.19.27.79-41.91 48.08-.28zM1442.03 465.05l.33 40.98-48.08-.19.23-40.52 47.52-.27zM1447.29 510.71l-.8 41.91 49.19.66-.32-41.92-48.07-.65zM1447.55 465.07l-.79 40.98 48.07.19.23-40.51-47.51-.66zM1548.96 511.11l.32 41.92-49.19.27.8-41.91 48.07-.28zM1549.22 465.48l.33 40.98-48.08-.19.24-40.52 47.51-.27zM698.26 415.69l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM799.93 416.1l.32 41.91-49.2.27.8-41.91 48.08-.27zM805.45 416.12l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM907.12 416.53l.32 41.91-49.2.27.8-41.91 48.08-.27zM912.64 416.55l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM1014.31 416.96l.32 41.91-49.19.27.79-41.91 48.08-.27zM1019.83 416.98l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM1121.5 417.39l.32 41.91-49.19.27.79-41.91 48.08-.27zM1127.02 417.41l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM1228.69 417.82l.32 41.91-49.19.27.8-41.91 48.07-.27zM1234.21 417.84l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM1335.88 418.25l.32 41.91-49.19.27.8-41.91 48.07-.27zM1341.4 418.27l-.79 41.91 49.18.66-.32-41.91-48.07-.66zM1443.07 418.68l.32 41.91-49.19.27.8-41.91 48.07-.27zM1448.59 418.7l-.79 41.91 49.18.66-.32-41.91-48.07-.66zM1550.26 419.11l.32 41.91-49.19.27.8-41.91 48.07-.27zM1604.6 510.25l.32 41.92-49.19.27.8-41.91 48.07-.28zM1604.86 464.62l.33 40.98-48.07-.19.23-40.52 47.51-.27zM1610.12 510.28l-.79 41.91 49.18.66-.32-41.92-48.07-.65zM1610.39 464.64l-.8 40.98 48.08.19.23-40.51-47.51-.66zM1711.79 510.68l.32 41.92-49.19.27.8-41.91 48.07-.28zM1712.05 465.05l.33 40.98-48.07-.19.23-40.52 47.51-.27zM1605.9 418.25l.32 41.91-49.19.27.8-41.91 48.07-.27zM1611.43 418.27l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM1713.1 418.68l.31 41.91-49.19.27.8-41.91 48.08-.27zM1720.44 510.49l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM1720.7 464.85l-.79 40.98 48.07.19.23-40.51-47.51-.66zM1822.11 510.9l.32 41.91-49.19.27.79-41.91 48.08-.27zM1822.37 465.26l.33 40.98-48.08-.19.24-40.51 47.51-.28zM1827.63 510.92l-.8 41.91 49.19.66-.32-41.91-48.07-.66zM1827.89 465.28l-.79 40.98 48.07.19.24-40.51-47.52-.66zM1929.3 511.33l.32 41.91-49.19.27.8-41.91 48.07-.27zM1929.56 465.69l.33 40.98-48.08-.19.24-40.51 47.51-.28zM1721.74 418.48l-.79 41.91 49.18.66-.32-41.91-48.07-.66zM1823.41 418.89l.32 41.91-49.19.27.8-41.91 48.07-.27zM1828.94 418.91l-.8 41.91 49.18.66-.31-41.91-48.07-.66zM1930.6 419.32l.32 41.91-49.19.27.8-41.91 48.07-.27zM2132.04 938.34l-.79-367.34-1192.78.5-.01-3.92L658 566.5l-1.47 371.25 1475.51.59z"
        />
        <path
          style={{
            fill: '#ffe01c',
          }}
          d="m690.15 585.39-.39 72.61 239.23 3.76-.39-74.51-238.45-1.86zM690.34 664.95l237.29 3.12.77 66.94-237.28-1.23-.78-68.83zM690.73 740.27l237.68 1.23.38 64.41-238.84-1.23.78-64.41zM689.78 810.01l.39 65.04 238.8 1.53v-65.22l-239.19-1.35z"
        />
        <path
          d="M766.43 461.73c-.8 11.44-8.18 19.1-8.6 40.75-.55 27.72-.34 61.44-.34 61.44l33.83 1.17s-.3-34.8-1.94-60.82c-1.32-20.97-9.08-27.05-11.15-41.3-1.65-11.35-2.5-22.1-2.5-22.1l-8.04.43s-.48 9.32-1.25 20.42Z"
          style={{
            fill: '#e9b800',
          }}
        />
        <g
          style={{
            clipPath: 'url(#kitchen-c)',
          }}
        >
          <path
            style={{
              fill: '#ffea97',
            }}
            d="m751.51 509.99 22.36-.18.57 31.09-22.56-.16-.37-30.75z"
          />
        </g>
        <path
          d="m766.43 452.81.23-11.08c0-1.25.86-2.25 1.95-2.27l5.97-.13c1.13-.02 2.08 1 2.12 2.28v11.14l-10.27.06Z"
          style={{
            fill: '#940c3b',
          }}
        />
        <path
          d="M794.42 471.75c-.97 10.04-8.47 16.8-9.23 35.79-.97 24.31-1.28 53.87-1.28 53.87l33.82.82s.23-30.51-1.01-53.31c-1-18.38-8.67-23.67-10.52-36.14-1.48-9.94-2.17-19.36-2.17-19.36l-8.05.43s-.62 8.18-1.56 17.92Z"
          style={{
            fill: '#3b7c5e',
          }}
        />
        <path
          d="m794.85 463.69.09-9.77c.02-1.09.89-1.98 1.98-2.01l5.97-.15c1.13-.03 2.06.86 2.09 1.99l.14 9.83-10.27.12Z"
          style={{
            fill: '#e30042',
          }}
        />
        <path
          d="M771.2 293.73s1.12 3.55 3.66 9.18 7.13 11.11 7.13 11.11l68.45-3.33s3.58-6.78 4.81-11.95c1.23-5.17 1.93-11.75 1.93-11.75l-85.98 6.73Z"
          style={{
            fill: '#f19eb0',
          }}
        />
        <path
          d="M771.13 304.38s.57 3.67 2.23 9.59c1.66 5.92 5.37 11.99 5.37 11.99l68.23 6.21s4.57-6.21 6.57-11.15 3.69-11.36 3.69-11.36l-86.08-5.28Z"
          style={{
            fill: '#428a3d',
          }}
        />
        <path
          d="M771.53 323.94s.83 3.62 2.89 9.41 6.19 11.58 6.19 11.58l68.49 1.45s4.13-6.52 5.78-11.58c1.65-5.07 2.89-11.58 2.89-11.58l-86.24.72Z"
          style={{
            fill: '#ef875c',
          }}
        />
        <path
          style={{
            fill: '#82b658',
          }}
          d="m1310.35 879.66-.48-293.31-176 1.71 1.96 289.71 174.52 1.89zM950.76 588.8l-1.4 286.76 175.69 1.51.54-290.51-174.83 2.24z"
        />
        <path
          style={{
            fill: '#49465a',
          }}
          d="M789.58 610.46v5.91l39.59.16v-5.89l-39.59-.18zM789.58 693.35v5.91l39.59.16v-5.9l-39.59-.17zM1112.12 650.51l5.46-.04-.1-39.01-5.44.03.08 39.02zM1141.84 648.51l5.46-.04-.1-39.01-5.44.03.08 39.02zM789.58 767.82v5.91l39.59.16v-5.9l-39.59-.17zM787.38 836.46v6.57l43.98.17v-6.54l-43.98-.2z"
        />
        <path
          style={{
            fill: '#009794',
          }}
          d="m848.53 524.16 13.37 37.15h68.09l14.64-36.66-96.1-.49z"
        />
        <g
          style={{
            clipPath: 'url(#kitchen-d)',
          }}
        >
          <path
            style={{
              fill: '#8cbb15',
            }}
            d="m845.3 528.79 102.96.6 2.23-37.57-109.2-1.19 4.01 38.16z"
          />
        </g>
        <path
          style={{
            fill: '#d29dc3',
          }}
          d="m718.91 279.32-.54 64.56 45.33-.21.41-64.7-45.2.35z"
        />
        <path
          d="m716.48 284.73 49.43.35s.15-10.43.06-11.61-1.57-1.61-2.71-1.61H719.1c-1.15.01-2.15.46-2.36 1.75-.21 1.29-.26 11.11-.26 11.11Z"
          style={{
            fill: '#444851',
          }}
        />
        <path
          d="M742.25 261.02c-4.98-.7-7.65 1.77-8.38 4.99-.77 3.38.32 7.53 4.99 8.66 4.75 1.15 9.09-1.92 9.38-5.49.27-3.41-1-7.47-5.98-8.16Z"
          style={{
            fill: '#444851',
          }}
        />
        <path
          style={{
            fill: '#f39843',
          }}
          d="m1679.66 877.92 1.56-294.33-174.01 1.24-2.07 291.2 174.52 1.89zM1321.76 585.09l.42 291.93 178.07.99-1.13-292.6-177.36-.32z"
        />
        <path
          style={{
            fill: '#49465a',
          }}
          d="m1484.9 646.17 5.46-.04-.1-39.01-5.44.03.08 39.02zM1518.06 645.54l5.45-.03-.1-39.02-5.43.04.08 39.01z"
        />
        <path
          style={{
            fill: '#a5ccdb',
          }}
          d="m2053.11 876.91-.48-293.32-174 1.24-.04 290.19 174.52 1.89zM1693.17 585.09l2.45 288.88 175.5-.35-.58-288.21-177.37-.32z"
        />
        <path
          style={{
            fill: '#49465a',
          }}
          d="m1856.32 646.17 5.46-.04-.11-39.01-5.43.03.08 39.02zM1889.47 645.54l5.46-.03-.1-39.02-5.44.04.08 39.01z"
        />
        <path
          style={{
            fill: '#ef833b',
          }}
          d="m1374.1 503.37 3.24 62.62 95.06 1.21 6.05-67.21-104.35 3.38z"
        />
        <path
          d="M1367.34 508.98h115.31l-.61-12.42-49.1-7.02-.47-11.16c-.05-1.18-1.07-2.1-2.28-2.07l-7.62.18c-1.12.03-2.04.85-2.17 1.92l-1.19 10.32-52.67 7.86.8 12.39Z"
          style={{
            fill: '#e64427',
          }}
        />
        <path
          d="m1195.01 566.54-.29-34.54 13.93-.29.29 11.03 16.25-.58s2.03 2.03 1.74 6.68c-.29 4.64-1.45 8.13-1.45 8.13l-16.54.29.29 9.87-14.22-.58Z"
          style={{
            fill: '#49465a',
          }}
        />
        <path
          style={{
            fill: '#49465a',
          }}
          d="m1219.68 545.83 1.89-18.77 2.68.32-1.26 18.61-3.31-.16zM1198.23 533.21s-1.42-71.12-1.58-77.75c-.16-6.62 1.12-9.81 2.84-13.25 1.89-3.78 3.47-6.47 7.88-8.36 4.42-1.89 17.24-6.04 20.82-6.78 3.78-.79 8.97.09 11.99 6.62 2.84 6.15 3.15 17.5 3.15 17.5l-8.04.47s-.29-6.26-.47-8.2c-.47-5.05-2.21-9.46-4.42-9.3-3.19.23-18.27 5.58-20.19 6.31-3.31 1.26-4.73 5.52-5.52 9.78-1.01 5.45.79 84.05.79 84.05l-7.25-1.1ZM633.07 572.53l1396.18.26-.33-10.94-1395.82-2.96-.03 13.64z"
        />
        <path
          style={{
            fill: '#fbf8f6',
          }}
          d="m901.09 96.66.56 310.67 1101.93 2.72-.04-310.34-1102.45-3.05z"
        />
        <path
          style={{
            fill: '#a5ccdb',
          }}
          d="m1305.9 396.35-.48-265.73-174.04-.94v264.78l174.52 1.89zM947.3 130.82l1.12 262.6 175.43.4.19-264.98-176.74 1.98z"
        />
        <path
          style={{
            fill: '#49465a',
          }}
          d="m1109.8 372.94 5.46-.04-.1-39.01-5.44.03.08 39.02zM1137.46 372.31l5.45-.03-.1-39.02-5.43.03.08 39.02z"
        />
        <path
          style={{
            fill: '#ffe01c',
          }}
          d="m1686.13 397.97-.47-265.73-174.05-.94v264.78l174.52 1.89zM1322.29 131.78l2.45 261.3 178.08.99-2.15-265.28-178.38 2.99z"
        />
        <path
          style={{
            fill: '#49465a',
          }}
          d="m1488.48 373.24 5.46-.04-.1-39.01-5.44.03.08 39.02zM1519.58 372.61l5.45-.03-.1-39.02-5.44.03.09 39.02z"
        />
        <path
          style={{
            fill: '#82b658',
          }}
          d="m2059.39 396.59-.48-265.74-174.04-.93V394.7l174.52 1.89zM1697.48 131.37l2.45 261.3 178.08.99-2.15-265.29-178.38 3z"
        />
        <path
          style={{
            fill: '#49465a',
          }}
          d="m1862.69 371.84 5.46-.03-.1-39.02-5.44.03.08 39.02zM1893.78 371.22l5.46-.04-.1-39.02-5.44.04.08 39.02z"
        />
        <path
          style={{
            fill: '#fbf8f6',
          }}
          d="m692.4 353.98 212.76 1.17v-14.19l-212.38-1.17-.38 14.19z"
        />
        <path
          style={{
            fill: '#f0f4f8',
          }}
          d="m-38.91-58.42 1.34 457.22 392.88-1.52V-62.97l-394.22 4.55z"
        />
        <path
          style={{
            fill: '#cbe4e8',
          }}
          d="m-19.33-38.73-.63 389.05 167.9-.34-.02-385.78-167.25-2.93zM162.55-38.73l-.63 389.05 167.9-.34-.02-385.78-167.25-2.93z"
        />
      </g>
    </svg>
  )
}

export default Kitchen
